import {
    VStack,
    Heading,
    Text,
    AccordionItem,
    AccordionPanel,
    Accordion,
    AccordionButton,
    Box,
    AccordionIcon,
    useColorModeValue,
    Container,
    Icon,
    Flex
} from "@chakra-ui/react";
import React from "react";
import { Helmet } from "react-helmet";
import { FaQuestionCircle } from "react-icons/fa";

const QA = [
    {
        question: "How to Register in the system?",
        answer: `On the main page of our site there is a button "Register". You just need to enter your email address and add your password twice.`
    },
    {
        question: "How to recharge the balance?",
        answer: `After successful registration you will be taken to your personal account. After clicking on the menu, the option of recharge will appear. Click on recharge to be forwarded to the payment page.`
    },
    {
        question: "I refilled the balance, but the money did not arrive, what should I do?",
        answer: `You can safely write about this to us. Please note that the terms for crediting funds to your personal account in the system may vary depending on the payment method.`
    },
    {
        question: "How quickly do SMS messages arrive?",
        answer: `The phone number you rent stays active for up to 20 minutes, which is enough to get the SMS code and complete the activation process.`
    },
    {
        question: "I took the number, but the SMS did not come, or the number is already registered.",
        answer: `If you did not receive the code from the service, then the money will not be withdrawn from your balance. We do not have penalties for unused numbers, but if you abuse this, we reserve the right to ban you.`
    },
    {
        question: "I received the code, but it does not fit, or it's wrong. Return the money!",
        answer: `If the code arrived, we consider the activation paid regardless of whether it worked for you or not, as we cannot verify it. If the code does not suit you, you can press the repeat button and request another code for this number - it's free. You can do it as many times as you like.`
    },
    {
        question: "How to change the password? I suspect my account was hacked.",
        answer: `If you doubt that you are using the account solely, write to technical support - we will "freeze" the account before changing the password. To change the password yourself, go to the "Account settings" tab, enter the old password and create a new one twice.`
    },
]

const Faq = () => {
    // Premium UI Colors
    const bg = useColorModeValue("gray.50", "gray.900");
    const cardBg = useColorModeValue("white", "gray.800");
    const textColor = useColorModeValue("gray.800", "white");
    const subTextColor = useColorModeValue("gray.600", "gray.400");
    const accentColor = useColorModeValue("brand.500", "brand.200");
    const expandedBg = useColorModeValue("brand.50", "whiteAlpha.100");
    const borderColor = useColorModeValue("gray.200", "gray.700");

    return (
        <>
            <Helmet>
                <title>FAQ | Techy India</title>
            </Helmet>
            <VStack
                w="100%"
                minH="100vh"
                bg={bg}
                spacing={0}
                align="stretch"
                py={8}
            >
                <Container maxW="container.lg">
                    <VStack spacing={8} align="center" w="100%">
                        <VStack spacing={3} textAlign="center">
                            <Flex
                                align="center"
                                justify="center"
                                bg={useColorModeValue("brand.100", "brand.900")}
                                p={3}
                                rounded="full"
                                color="brand.500"
                            >
                                <Icon as={FaQuestionCircle} boxSize={6} />
                            </Flex>
                            <Heading
                                fontSize={{ base: "2xl", md: "4xl" }}
                                fontWeight="800"
                                color={textColor}
                                letterSpacing="-0.5px"
                            >
                                Frequently Asked <Text as="span" color="brand.500">Questions</Text>
                            </Heading>
                            <Text color={subTextColor} fontSize="lg" maxW="600px">
                                Have questions? We're here to help. Find answers to the most common questions about our service.
                            </Text>
                        </VStack>

                        <Accordion allowToggle w="100%" allowMultiple>
                            {QA.map((el, index) => (
                                <AccordionItem
                                    key={index}
                                    border="1px solid"
                                    borderColor={borderColor}
                                    bg={cardBg}
                                    mb={4}
                                    rounded="xl"
                                    overflow="hidden"
                                    shadow="sm"
                                    transition="all 0.2s"
                                    _hover={{ shadow: "md" }}
                                >
                                    {({ isExpanded }) => (
                                        <>
                                            <h2>
                                                <AccordionButton
                                                    _expanded={{ bg: expandedBg, color: "brand.500" }}
                                                    p={6}
                                                    _hover={{ bg: isExpanded ? expandedBg : "gray.50" }}
                                                >
                                                    <Box flex="1" textAlign="left" fontWeight="600" fontSize="lg">
                                                        {el.question}
                                                    </Box>
                                                    <AccordionIcon fontSize="24px" />
                                                </AccordionButton>
                                            </h2>
                                            <AccordionPanel pb={6} px={6} color={subTextColor} fontSize="md" lineHeight="tall">
                                                {el.answer}
                                            </AccordionPanel>
                                        </>
                                    )}
                                </AccordionItem>
                            ))}
                        </Accordion>
                    </VStack>
                </Container>
            </VStack>
        </>
    );
};

export default Faq;
